module.exports = __webpack_public_path__ + "img/logo.54133429.svg";